import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export interface IConfirmActionModal {
    text: string;
    additionalText?: string;
    onConfirm: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
}

interface Props {
    data: IConfirmActionModal;
    className?: string;
}

export const ConfirmActionModal = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);

    return (
        <S_ConfirmActionModal className={props.className}>
            <S_Title>{props.data.text}</S_Title>
            {props.data.additionalText && <S_Subtitle>{props.data.additionalText}</S_Subtitle>}
            <S_Buttons>
                <S_Cancel
                    type="whiteRec"
                    onClick={() => {
                        if (props.data.onCancel) {
                            props.data.onCancel();
                        }
                        ctxModal.setModal(null);
                    }}
                    text={props.data.cancelText ? props.data.cancelText : Localization.CANCEL}
                />
                <S_WebButtonSmaller
                    type="primary"
                    onClick={() => {
                        props.data.onConfirm();
                        ctxModal.setModal(null);
                    }}
                    text={props.data.confirmText ? props.data.confirmText : Localization.CONFIRM}
                />
            </S_Buttons>
        </S_ConfirmActionModal>
    );
};

const S_ConfirmActionModal = styled.div`
    padding: 45px 50px;
    z-index: 1;
`;

const S_Title = styled.div`
    color: white;
    font-size: 18px;
    font-family: ${EFonts.Medium};
    text-align: center;
    width: 100%;
    line-height: 25px;
    white-space: pre-line;
`;

const S_Subtitle = styled.div`
    color: white;
    font-size: 14px;
    margin-top: 20px;
    font-family: ${EFonts.Regular};
    text-align: center;
    width: 100%;
    white-space: pre-line;
`;

const S_Buttons = styled.div`
    margin: 30px 0 10px 0;
    display: flex;
    width: 100%;
    justify-content: center;
`;

const S_Cancel = styled(S_WebButtonSmaller)`
    margin: 0 20px 0 0;
`;
